<div class="row" *ngFor="let tl of teamsList; let i = index">
  <div class="row-line" [ngClass]="{ disabled: tl.state != 'Activo' }">
    <p [ngStyle]="{ width: tableHeader[0].percentageWidth + '%' }" class="name">
      <span>{{ tl.name }}</span>
      <qr-icon
        *ngIf="tl.state != 'Activo'"
        name="info"
        color="error-700"
        matTooltip="Team inactivo"
      ></qr-icon>
    </p>
    <p
      [ngStyle]="{ width: tableHeader[1].percentageWidth + '%' }"
      class="count"
    >
      {{ tl.numberMembers }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[2].percentageWidth + '%' }"
      class="closing"
    >
      {{
        userCurrency == "USD"
          ? "U$S " + formatNumber(tl.closeUSD)
          : "$ " + formatNumber(tl.close)
      }}
    </p>
    <p
      [ngStyle]="{ width: tableHeader[3].percentageWidth + '%' }"
      class="antiquity"
    >
      {{ tl.antiquity }}
    </p>
    <div
      [ngStyle]="{ width: tableHeader[4].percentageWidth + '%' }"
      class="action"
    >
      <qr-button
        [config]="buttonMoreActions"
        matTooltip="Más acciones"
        [matMenuTriggerFor]="menu"
      ></qr-button>
      <qr-button
        class="expand"
        [ngClass]="{ open: this.itemExpand == i }"
        (click)="onExpandItem(i)"
        [config]="buttonExpand"
        matTooltip="Expandir"
      ></qr-button>

      <!-- MENU DESPLEGABLE MORE ACTIONS -->
      <mat-menu #menu="matMenu" class="menu-more-actions">
        <button
          mat-menu-item
          (click)="onModifTeam(tl.state, i)"
          [ngClass]="{ 'disabled-btn': tl.state != 'Activo' }"
        >
          <div class="menu-option">
            <qr-icon name="pencil" color="grey-600"></qr-icon>
            <span>Modificar</span>
          </div>
        </button>
        <button
          mat-menu-item
          (click)="onButtonRemoveTeam(tl.id)"
          [ngClass]="{ 'disabled-btn': tl.state != 'Activo' }"
        >
          <div class="menu-option">
            <qr-icon name="agent-remove" color="grey-600"></qr-icon>
            <span>Dar de baja</span>
          </div>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="row-expand" [ngClass]="{ open: this.itemExpand == i }">
    <!-- 1° COLUMNA: LÍDER -->
    <div class="column-box leader">
      <div class="box">
        <ng-container *ngIf="!isLoadingTeamDetail">
          <div class="profile-photo">
            <qr-avatar
              [size]="80"
              [src]="
                this.teamDetail && this.teamDetail.photo
                  ? this.teamDetail.photo
                  : ''
              "
            ></qr-avatar>
            <div
              class="status"
              [ngClass]="{ disabled: tl?.state != 'Activo' }"
            ></div>
          </div>
          <div class="agent-info">
            <p class="name">{{ print(this.teamDetail?.name) }}</p>
            <p class="type">{{ print(this.teamLeaderName) }}</p>
            <p class="office">RE/MAX {{ print(this.teamDetail?.agency) }}</p>
          </div>
        </ng-container>
        <div class="loader" *ngIf="isLoadingTeamDetail">
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
        </div>
      </div>
    </div>

    <!-- 2° COLUMNA: MIEMBROS -->
    <div class="column-box members">
      <div class="box">
        <div class="row-member table-header">
          <span>Agente</span>
          <span>Fecha de alta</span>
          <span>Fecha de baja</span>
        </div>
        <div class="scrolleable" *ngIf="!isLoadingTeamDetail">
          <div
            class="row-member table-body"
            [ngClass]="{ inactive: td.modificationStateDate }"
            *ngFor="let td of teamDetail?.members"
          >
            <span class="agent agent--clickable" (click)="onGoToAgent(td)">
              {{ td.name + " " + td.lastname }}
              <qr-icon
                [name]="ICON_ARROW_RIGHT_UP"
                [color]="td.modificationStateDate ? 'grey-700' : 'primary-500'"
                matTooltip="Ver agente"
                matTooltipPosition="above"
                matTooltipClass="team-link-tooltip"
              ></qr-icon>
            </span>
            <span>{{ print(td.createdDate | date : "dd/MM/yyyy") }}</span>
            <span>{{
              print(td.modificationStateDate | date : "dd/MM/yyyy")
            }}</span>
          </div>
          <div
            class="empty-members-team"
            *ngIf="
              teamDetail && teamDetail.members && teamDetail.members.length == 0
            "
          >
            No hay ningún miembro
          </div>
        </div>
        <div class="loader" *ngIf="isLoadingTeamDetail">
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
          <div class="loader-line">
            <qr-skeleton-loader></qr-skeleton-loader>
          </div>
        </div>
      </div>
    </div>

    <!-- 3° COLUMNA: CIERRES -->
    <div class="column-box closures">
      <div class="box">
        <p>Cierres</p>
        <h2>
          {{
            userCurrency == "USD"
              ? "U$S " + formatNumber(this.teamDetail?.closeUSD)
              : "$ " + formatNumber(this.teamDetail?.close)
          }}
        </h2>
        <qr-button *ngIf="false" [config]="buttonClosures"></qr-button>
      </div>
      <div class="buttons">
        <qr-button
          [config]="buttonModif"
          (click)="onModifTeam(tl.state)"
          [isDisabled]="tl.state != 'Activo'"
        ></qr-button>
        <qr-button
          [config]="buttonRemoveTeam"
          (click)="onButtonRemoveTeam(tl.id)"
          [isDisabled]="tl.state != 'Activo'"
        ></qr-button>
      </div>
    </div>
  </div>
</div>
<div class="empty" *ngIf="teamsList.length == 0">
  <h2 class="display-02-semi-bold">Ningún resultado</h2>
</div>
